export default "__VITE_ASSET__gW459RWb__"